import styled from "styled-components"

export interface StyledStatsContainerProps {
  accent_style: string
  remove_top_spacer: string
}
export interface StyledStatsProps {
  accent_style: string
}

export const StyledStats = styled.div``
export const StyledContainer = styled.div<StyledStatsContainerProps>`
  display: flex;
  ${(props) =>
    props.accent_style === "top"
      ? `
    flex-direction: column;
  `
      : `
    padding-top: 52px;
  `}

  ${props => props.remove_top_spacer === "desktop" && (`
    @media (max-width: ${props.theme.breakPoints.wide}) {
      padding-top: 0;
    }
  `)}
  ${props => props.remove_top_spacer === "tablet" && (`
    @media (max-width: ${props.theme.breakPoints.desktop}) {
      padding-top: 0;
    }
  `)}
  ${props => props.remove_top_spacer === "mobile" && (`
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      padding-top: 0;
    }
  `)}
`
export const StyledAccent = styled.p<StyledStatsProps>`
  font-family: ${(props) => props.theme.fonts.circularMedium};
  font-size: 44px;
  line-height: 48px;
  color: ${(props) => props.theme.colors.darkGrey};
  margin: 0;
  line-height: 1;
  ${(props) =>
    props.accent_style === "right" &&
    `
    order: 1;
  `}
  ${(props) =>
    props.accent_style === "top" &&
    `
    margin-bottom: 8px;
  `}
`
export const StyledValue = styled.p<StyledStatsProps>`
  font-family: ${(props) => props.theme.fonts.circularMedium};
  font-size: 140px;
  line-height: 144px;
  color: ${(props) => props.theme.colors.darkGrey};
  margin: 0;
  ${(props) =>
    props.accent_style === "right" &&
    `
    order: 0;
  `}
`
export const StyledText = styled.div`
  ${(props) => props.theme.mixins.body}
  margin-top: 16px;

  & p {

  }
`
